import { findWorkToastKeyByAwaitingInputId, useWorkToastStore } from "@/stores/work-toast-store";

/** Whether a live (non-dismissed) work-toast pill holds this question, by its
 *  awaiting-input id — used by the cursor "?" badge to decide whether it has
 *  somewhere to go, and by the compact cursor to decide whether the badge
 *  will render. A boolean selector so callers only re-render when the answer
 *  changes (a pill appearing later, being removed, or dismissed), not on
 *  every unrelated work-toast store update. */
export function useHasWorkToastQuestion(awaitingInputId: string): boolean {
  return useWorkToastStore((s) => {
    const key = findWorkToastKeyByAwaitingInputId(s.items, awaitingInputId);
    const item = key ? s.items[key] : undefined;
    return !!item && !item.dismissed;
  });
}
